document.addEventListener('DOMContentLoaded', function(e) {
    let sliders = document.querySelectorAll('.slider-wrapper');

    if (sliders) {

        sliders.forEach(slider=> {
            let currpos = parseInt(slider.dataset.pos);
            let end = parseInt(slider.dataset.total);

            let prevBtn = slider.querySelector('.navigation button.prev');
            let nextBtn = slider.querySelector('.navigation button.next');

            prevBtn.addEventListener('click', function(e) {
                e.preventDefault();
                currpos = parseInt(slider.dataset.pos);
                prev(slider, currpos, end);
            })

            nextBtn.addEventListener('click', function(e) {
                e.preventDefault();
                currpos = parseInt(slider.dataset.pos);
                next(slider, currpos, end);
            })
        })
    }

    function next(slider, currpos, end) {
        let target = currpos + 1;

        if (target > end) {
            target = 1;
        }

        slider.dataset.pos = target;
    }
    
    function prev(slider, currpos, end) {
        let target = currpos - 1;

        if (target < 1) {
            target = end;
        }

        slider.dataset.pos = target;
    }
})